module.exports = __webpack_public_path__ + "904cba3bdd9dc024bf3a01654231c020.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/veroffentlichungen/N4 jausschnitt.jpg
// module id = 382
// module chunks = 0